import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from 'file-saver';
import { baseUrl, getDateWithDay, requirementStatusList } from "../../comman/config";
import { VegRequirementFilter } from "../../components/Filter/VegRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import IngredientBatchModel from "../../components/IngredientBatchModel.js";
import OrderIngredientModel from "../../components/OrderIngredientModel.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import Loader from "../../components/Loader.js";
import Select from 'react-select';
import * as XLSX from "xlsx";
import { menuAboveTable } from "../../comman/selectMenu";
// import Pagination from "react-js-pagination";

function OrderList() {
  const today = new Date().toISOString().split("T")[0];
  const [ingredientOrderList, setIngredientOrderList] = useState([]);
  const [orderStatus, setOrderStatus] = useState({});
  const [orderId, setOrderId] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ingredient, setIngredient] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [orderIngedientList, setOrderIngredientList] = useState(null);
  const [itemIngedientList, setItemIngredientList] = useState(null);
  const [methodList, setMethodList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [ingredientList, setIngredientList] = useState([]);

  useEffect(() => {
    getMethodList()
  }, []);
useEffect(() => {
  getIngredientOrderList();
}, [fromDate, toDate, ingredient, orderStatus, orderId])

  useEffect(() => {
    console.log(ingredientOrderList)
    getIngredientList()
  }, [ingredientOrderList])

  const handelFilterChange = async (from_date, to_date, session, item, requirement_status, order_status, order_id, purchase_status, receipt_status,issueStatus,ingredient) => {
        setFromDate(from_date);
        setToDate(to_date);
        setIngredient(ingredient);
        setOrderStatus(order_status);
        setOrderId(order_id); 
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = ingredientOrderList.map(item => item.ingredient_id);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };
  // const getIngredientOrderList = async() => {
  //   setLoading(true)
  //   setNoRecordsFound(false)
  //   const response = await axios.post(`${baseUrl}/order/list`,
  //     { from_date : fromDate,
  //       to_date :toDate,
  //       ingredient : ingredient?.value,
  //       order_status: orderStatus?.value,
  //       order_id : orderId?.value
       
  //   });
  //   const condition = (item) => `ird.date = '${item.date}' AND ird.ingredient_id = '${item.ingredient_id}' AND irm.requirement_status = 2 AND irm.ingredient_added = 2 AND ing.store = 3`;
  //   const fetchUpdatedArray = async (responseData) => {
  //     const updatedArray = [];
    
  //     for (const item of responseData.data.data) {
  //       // Construct the condition based on the current item
  //       const conditionString = condition(item);
    
  //       // Make the API call with the condition
  //       const RecipeDbData = await axios.get(`${baseUrl}/order/ingredient_list?condition=${conditionString}`);
    
  //       // Get the ingredients list from the API response
  //       const ingredientsList = RecipeDbData.data.data;
  //       const popupQty = ingredientsList.reduce((sum, ingredient) => sum + parseFloat((ingredient.gross_required_qty || 0)), 0).toFixed(2);
  //       // Update the item with the new data
  //       const updatedItem = {
  //         ...item,
  //         order_qty: item.order_qty ?? "", // Add the order_qty key-value pair
  //         popupQty, // Add the ingredientsList from the API response
  //       };
    
  //       // Add the updated item to the array
  //       updatedArray.push(updatedItem);
  //     }
    
  //     return updatedArray;
  //   };
  //   const updatedArray = await fetchUpdatedArray(response);
  //   setIngredientOrderList(updatedArray);
  //   setNoRecordsFound(updatedArray.length === 0);
  //   setLoading(false)
  // }

  // Frontend optimization
// Frontend Optimization
  const getIngredientOrderList = async () => {
    setLoading(true);
    setNoRecordsFound(false);

    try {
      // 1. First, get the basic order list
      const response = await axios.post(`${baseUrl}/order/list`, {
        from_date: fromDate,
        to_date: toDate,
        ingredient: ingredient?.value,
        order_status: orderStatus?.value,
        order_id: orderId?.value
      });

      if (!response.data.data || response.data.data.length === 0) {
        setIngredientOrderList([]);
        setNoRecordsFound(true);
        return;
      }

      // 2. Create a batch API request for all items at once
      const itemsData = response.data.data.map(item => ({
        date: item.date,
        ingredient_id: item.ingredient_id
      }));

      // Send all data in a single batch request
      const batchResponse = await axios.post(`${baseUrl}/order/batch_list`, {
        items: itemsData
      });

      // 3. Map the response data back to the original items
      const updatedArray = response.data.data.map((item, index) => {
        const popupData = batchResponse.data.data[index] || [];
        const popupQty = popupData.reduce(
          (sum, ingredient) => sum + parseFloat((ingredient.gross_required_qty || 0)),
          0
        ).toFixed(2);

        return {
          ...item,
          order_qty: item.order_qty ?? "",
          available_qty: item.available_qty ?? 0,
          popupQty,
          ingredientsList: popupData
        };
      });

      setIngredientOrderList(updatedArray);
      setNoRecordsFound(updatedArray.length === 0);
    } catch (error) {
      console.error("Error fetching ingredient order list:", error);
      setIngredientOrderList([]);
      setNoRecordsFound(true);
    } finally {
      setLoading(false);
    }
  };


  
  const handleSubmit = async() => {
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    // if(selectedRows.some(item => item.order_qty === "")){
    //   alert("One or more items have an empty order qty value.");
    //   setSelectedRows([]);
    //   return;
    // }
    // Patch: fill empty order_qty with calculated value
    const patchedRows = selectedRows.map(item => ({
      ...item,
      order_qty: (item.order_qty !== undefined && item.order_qty !== null && item.order_qty !== '')
        ? item.order_qty
        : item.gross_required_qty - (item.available_qty ?? 0)
    }));

    if (patchedRows.some(item => item.order_qty === "" || item.order_qty === undefined || item.order_qty === null)) {
      alert("One or more items have an empty order qty value.");
      setSelectedRows([]);
      return;
    }
    if(patchedRows.length > 0){
      setOrderIngredientList(patchedRows);
      try{
        if(window.confirm(`આ શાકભાજી "ઓર્ડર" થવા જઈ રહી છે. હવે પછી "ઓર્ડર" માં કોઈ સુધારો થઇ શકશે નહી .
  કોઈ કારણસર કોઈ સુધારો કરવાનો થાય તો "શાકભાજી પરચેઝ (ખરીદ) ટીમ" ને જાણ કરવી.
  શું તમે "ઓર્ડર" કરવા માંગો છો ?`)){
          const response = await axios.post(`${baseUrl}/order/ingredient_place_order`,
            { ingredientsList : patchedRows});
          const msg = response.data.msg;
          toast.success(msg);
          
          getIngredientOrderList();
        }
      }catch (error) {
        toast.error("Failed to add item. Please try again.");
      }
      // setShowOrderModal(true);
    }
    setSelectedRows([]);
  };

  const handleSave = async() => {
    setLoading(true);
    // if(selectedRows.length == 0){
    //   alert("Please select at least one row");
    //   setSelectedRows([]);
    //   setLoading(false);
    //   return;
    // }
    console.log(selectedRows);
    // if(selectedRows.some(item => item.order_qty === "")){
    //   alert("One or more items have an empty order qty value.");
    //   setSelectedRows([]);
    //   setLoading(false);
    //   return;
    // }
    // if(selectedRows.length > 0){
      try{
        const response = await axios.post(`${baseUrl}/order/ingredient_save`,
          { 
            ingredientsList : ingredientOrderList
          });
          toast.success("Data save sucessfully.");
          await getIngredientOrderList();
          setLoading(false);
      }catch (error) {
        toast.error("Failed to add item. Please try again.");
        setLoading(false);
      }
    // }
  }

  const handleExport = async (e) => {
    e.preventDefault();
    try {
      const headerRow = [
        "Meal Date",
        "Ingredient",
        "Gross Req.Qty",
        "Available Stock",
        "Order Qty",
        "Order Status",
        "Order Id",
      ];
  
      const data = ingredientOrderList.map((item) => {
        // Replace status values with "Pending Order" or "Order Place"
        const status =
          item.order_status == 1 || item.order_status == 2
            ? "Pending Order"
            : "Order Place";
  
        return [
          item.date,
          item.ingredient,
          item.gross_required_qty,
          item.available_qty,
          item?.order_qty ?? "",
          status,
          item.order_id,
        ];
      });
  
      // Combine header row and data
      const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...data]);
  
      // Create a new workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  
      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
      // Create a Blob and trigger download
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "order.xlsx");
    } catch (error) {
      toast.error("Failed to export item. Please try again.");
    }
  };

  const handleAddNewIngredientRow = () => {
    setIngredientOrderList([...ingredientOrderList, {
      ingredient: '',
      ingredient_obj:{},
      ingredient_id: null,
      gross_required_qty: 0,
      order_qty: '',
      available_qty: '',
      order_status: 1,
      isNew: true
    }]);
    console.log("ingredient list:", ingredientOrderList)
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setIngredientOrderList((prevFormData) => {
      const updatedFormData = [...prevFormData];
     
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      return updatedFormData;
    });
  };

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientOrderList[index])
        ? selectedRows.filter(item => item !== ingredientOrderList[index]) // Deselect
        : [...selectedRows, ingredientOrderList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
    

};
const handleSwitchSelectAll = () => {
  if (selectAll) {
      setSelectedRows([]);
  } else {
      setSelectedRows(ingredientOrderList.filter((item) => item.order_status == 1)); // Select all rows
  }
  setSelectAll(!selectAll);
};

  const displayIngredientDetail = async(e, item) => {
    e.preventDefault();
    setLoading(true)
    const condition = `ird.date = '${item.date}' AND ird.ingredient_id = '${item.ingredient_id}' AND irm.requirement_status = 2 AND irm.ingredient_added = 2`;
    const RecipeDbData = await axios.get(`${baseUrl}/order/ingredient_list?condition=${condition}`);
    const ingredientsList = RecipeDbData.data.data;
    
    setItemIngredientList(ingredientsList);
    setLoading(false)
    setShowModal(true);
  }

  const clearItem = () => {
    setSelectedRows([]);
    setItemIngredientList(null);
    setOrderIngredientList(null);
    getIngredientOrderList();
  };

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    console.log(selectedOptions)
    const updatedList =   [...ingredientOrderList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    setIngredientOrderList(updatedList)
  }

  console.log("ingredientOrderList", ingredientOrderList)

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:2xl font-bold">
          Order
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="order" />
      </div>
      {noRecordsFound && <NoRecordsFound />}
      {ingredientOrderList.length > 0 && (
        <>
          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-visible">
            <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center">
                    <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                  </th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Meal Date</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Ingredient</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Gross Req. Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Available Stock (Gross)</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Order Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Order Status</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Order Id</th>
                </tr>
              </thead>
              <tbody>
                {ingredientOrderList.map((item, index) => (
                  <tr key={index} className="border border-black-b">
                    {!(item.order_status == 3 && item.purchase_status == 3) &&
                      <td className="px-2 py-1 border border-black text-center">
                        <input type="checkbox" checked={selectedRows.includes(item)} onChange={() => handleToggleSelect(index)} />
                      </td>
                    }
                    {(item.order_status == 3 && item.purchase_status == 3) &&
                      <td className="px-2 py-1 border border-black text-center"></td>
                    }
                    <td className="px-2 py-1 border border-black text-center">{getDateWithDay(item.isNew ? new Date() : item.date)}</td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.isNew ? (
                        <Select
                          {...menuAboveTable}
                          classNamePrefix="select"
                          className='basic-multi-select'
                          value={item.ingredient_obj}
                          name="ingredient"
                          onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                          options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            unit: item.unit?.id,
                            ingredient: `${item.ingredient}`,
                            eng_name: item.eng_name,
                          }))}
                          placeholder="Ingredient List"
                          filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        />
                      ) : (item.ingredient)}
                    </td>
                    <td className={`px-2 py-1 border border-black text-center ${item.popupQty != item.gross_required_qty ? "bg-green-200" : ""}`}>
                      <a href="#" className="underline text-blue-500" onClick={(e) => displayIngredientDetail(e, item)}>
                        {item.gross_required_qty}
                      </a>
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      <input type="number"
                        id="available_qty"
                        name="available_qty"
                        value={item?.available_qty ?? 0}
                        onChange={handleInputChange(index)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className={`px-2 py-1 border rounded-md w-20 ${item.order_status == 3 && item.purchase_status == 3 ? "" : "bg-orange-50"}`}
                      />
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      <input type="number"
                        id="order_qty"
                        name="order_qty"
                        value={item.order_qty !== undefined && item.order_qty !== null && item.order_qty !== ''
                          ? item.order_qty
                          : item.gross_required_qty - (item.available_qty ?? 0)}
                        onChange={handleInputChange(index)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className={`px-2 py-1 border rounded-md w-20 ${item.order_status == 3 && item.purchase_status == 3 ? "" : "bg-orange-50"}`}
                      />
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.order_status == 1 ? "Pending Order" : (item.order_status == 2 ? "Pending Order" : "Order Place")}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.order_id}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="lg:hidden mt-6 space-y-4">
            <div className="mb-4 flex justify-between items-center">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className="newrow checkboxAll"
                  onChange={handleSwitchSelectAll}
                  checked={selectAll}
                />
                <label className="text-sm font-medium">Select All</label>
              </div>
            </div>

            {ingredientOrderList.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm p-4">
                <div className="space-y-3">
                  {/* Header with checkbox and status */}
                  <div className="flex justify-between items-start">
                    <div className="flex items-center space-x-2">
                      {!(item.order_status == 3 && item.purchase_status == 3) && (
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(item)}
                          onChange={() => handleToggleSelect(index)}
                          className="mt-1"
                        />
                      )}
                      {item.order_id && (
                        <div>
                          <p className="text-xs text-gray-500">Order ID</p>
                          <p className="text-sm font-medium">{item.order_id}</p>
                        </div>
                      )}
                    </div>

                    <div className="text-right">
                      <p className="text-xs text-gray-500 mb-1">Status</p>
                      <p className="text-sm font-medium text-gray-900">
                        {item.order_status == 1 ? "Pending Order" : (item.order_status == 2 ? "Pending Order" : "Order Place")}
                      </p>
                    </div>
                  </div>

                  {/* Ingredient Selection - Now at top */}
                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Ingredient</label>
                    {item.isNew ? (
                      <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={item.ingredient_obj}
                        name="ingredient"
                        onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                        options={ingredientList.map((item) => ({
                          value: item.id,
                          label: `${item.ingredient} (${item.eng_name})`,
                          unit: item.unit?.id,
                          ingredient: `${item.ingredient}`,
                          eng_name: item.eng_name,
                        }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                          return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      />
                    ) : (
                      <p className="text-sm font-medium text-gray-900">{item.ingredient}</p>
                    )}
                  </div>

                  {/* Gross Required Quantity and Date row */}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Gross Required Qty</label>
                      <button
                        onClick={(e) => displayIngredientDetail(e, item)}
                        className={`text-sm font-medium underline text-blue-500 ${item.popupQty != item.gross_required_qty ? "bg-green-200 px-2 py-1 rounded" : ""}`}
                      >
                        {item.gross_required_qty}
                      </button>
                    </div>

                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Date</label>
                      <div>
                        <p className="text-sm font-medium text-gray-900">
                          {getDateWithDay(item.isNew ? new Date() : item.date)}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Input Fields */}
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Available Stock (Gross)</label>
                      <input type="number"
                        id="available_qty"
                        name="available_qty"
                        value={item?.available_qty ?? 0}
                        onChange={handleInputChange(index)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className={`px-2 py-1 border rounded-md w-full text-sm ${item.order_status == 3 && item.purchase_status == 3 ? "" : "bg-orange-50"}`}
                      />
                    </div>

                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Order Qty</label>
                      <input type="number"
                        id="order_qty"
                        name="order_qty"
                        value={item.order_qty !== undefined && item.order_qty !== null && item.order_qty !== ''
                          ? item.order_qty
                          : item.gross_required_qty - (item.available_qty ?? 0)}
                        onChange={handleInputChange(index)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className={`px-2 py-1 border rounded-md w-full text-sm ${item.order_status == 3 && item.purchase_status == 3 ? "" : "bg-orange-50"}`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <IngredientBatchModel showModal={showModal} setShowModal={setShowModal} detailList={itemIngedientList} clearItem={clearItem} type={1} />
      <OrderIngredientModel showOrderModal={showOrderModal} setShowOrderModal={setShowOrderModal} ingredientList={orderIngedientList} clearItem={clearItem} />

      {ingredientOrderList.length > 0 && (
        <div className="m-5 space-y-2 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row">
          {ingredientOrderList.every(item => item.order_status === 1) && (
            <button
              onClick={handleSave}
              className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Save
            </button>
          )}
          <button
            onClick={handleAddNewIngredientRow}
            className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
          >
            Add Ingredient
          </button>
          <button
            onClick={handleSubmit}
            className="w-full sm:w-auto px-4 py-2 bg-rose-500 text-white rounded-md hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200"
          >
            Place for Order
          </button>
          <button
            onClick={handleExport}
            className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
          >
            Export
          </button>
        </div>
      )}
    </div>
  );
}

export default OrderList;
